<p-dialog
  [(visible)]="displayMessage"
  [style]="{ minWidth: '30vw', maxWidth: '600px' }"
  [baseZIndex]="10000"
  [modal]="true"
  [dismissableMask]="false"
  [closable]="false"
  [styleClass]="'kanzi-alert-dialog kanzi-alert-' + (message?.type || 'info')"
>
  <ng-template pTemplate="header">
    <div class="alert-header">
      <div class="alert-icon-wrapper" [ngClass]="'alert-icon-' + (message?.type || 'info')">
        <i 
          class="pi" 
          [ngClass]="{
            'pi-check-circle': message?.type === 'success',
            'pi-exclamation-triangle': message?.type === 'warning',
            'pi-times-circle': message?.type === 'error'
          }"
        ></i>
      </div>
      <div class="alert-title">
        <h3>{{ title | translate }}</h3>
      </div>
    </div>
  </ng-template>

  <div class="alert-content">
    <div class="alert-message" [innerHTML]="message?.text || '' | translate"></div>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert-actions">
      <button
        *ngIf="message && message.link"
        type="button"
        pButton
        icon="pi pi-eye"
        (click)="goDetail()"
        [label]="'alerts.view_details' | translate"
        class="p-button-outlined"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-times"
        (click)="closeModal()"
        [label]="'alerts.close' | translate"
        [ngClass]="{
          'p-button-danger': message && message.type === 'error',
          'p-button-success': message && message.type === 'success',
          'p-button-warning': message && message.type === 'warning'
        }"
      ></button>
    </div>
  </ng-template>
</p-dialog>
